import { Component, Watch, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { objAny } from "@/common/common-interface";
@Component
export default class TableMaxHeightMixins extends Vue {
  @State("sys") sys!: objAny;
  @Watch("sys.winOnresize")
  getVisible(): void {
    this.getflexScrollHeight();
  }

  private activatedFlag = false;
  private isInItactivatedFlag = false;
  private tableMaxHeight = 1000;

  public getflexScrollHeight(): void {
    if (this.activatedFlag) {
      this.$nextTick(() => {
        const flexScroll: objAny = this.$refs.flexScroll || {};
        if (flexScroll) {
          if (flexScroll.$el && flexScroll.$el.offsetHeight) {
            this.tableMaxHeight = flexScroll.$el.offsetHeight;
          }
        }
        if (!this.isInItactivatedFlag) {
          this.isInItactivatedFlag = true;
        }
      });
    }
  }
  mounted(): void {
    this.activatedFlag = true;
    this.getflexScrollHeight();
  }
  activated(): void {
    if (this.isInItactivatedFlag) {
      this.activatedFlag = true;
      this.getflexScrollHeight();
    }
  }
  deactivated(): void {
    this.activatedFlag = false;
  }
}
